"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addRentersCommands = void 0;
var ProcessSessionStorageValuableItem_1 = require("./ProcessSessionStorageValuableItem");
var MapValuableItemIdsToRealEstate_1 = require("./MapValuableItemIdsToRealEstate");
var HandleRentersAssumptionsPopupCommand_1 = require("./HandleRentersAssumptionsPopupCommand");
var CheckAddressChangeCommand_1 = require("./CheckAddressChangeCommand");
var addRentersCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "processSessionStorageValuableItem",
        component: ProcessSessionStorageValuableItem_1.ProcessSessionStorageValuableItem
    });
    extensions.journeyComponents.addCommand({
        id: "mapValuableItemIdsToRealEstate",
        component: MapValuableItemIdsToRealEstate_1.MapValuableItemIdsToRealEstate
    });
    extensions.journeyComponents.addCommand({
        id: "handleRentersAssumptionsPopup",
        component: HandleRentersAssumptionsPopupCommand_1.HandleRentersAssumptionsPopupCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkAddressChange",
        component: CheckAddressChangeCommand_1.CheckAddressChangeCommand
    });
};
exports.addRentersCommands = addRentersCommands;
//# sourceMappingURL=index.js.map